import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-ro',
  templateUrl: './terms-ro.component.html',
  styleUrls: ['./terms-ro.component.scss']
})
export class TermsRoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
